// GENERATED by registry/gen-family.mjs from registry/apps.json — do not edit.
// Run `node registry/gen-family.mjs` to regenerate. Apps import this and
// filter out their own entry when rendering <MoreFromUs>.
import type { FamilyApp } from './MoreFromUs';

export const FAMILY: readonly FamilyApp[] = [
  { name: "Hive", tagline: "The bug board game, online with a friend", glyph: "🐝", url: "https://hive.zackmfleischman.com" },
  { name: "Lex", tagline: "A crossword tile game for 2–4", glyph: "🅻" },
  { name: "Checkers", tagline: "Draughts, online with a friend", glyph: "⛃" },
  { name: "Tafl", tagline: "The Viking siege game, for two", glyph: "⚔️", url: "https://tafl.pages.dev" },
  { name: "Sudoku", tagline: "A calm daily puzzle", glyph: "🔢", url: "https://sudoku-zmf.pages.dev" },
  { name: "Bricks", tagline: "The wall, the paddle, the ball", glyph: "🧱", url: "https://breakout-zmf.pages.dev" },
  { name: "Stillness", tagline: "A quiet meditation timer", glyph: "🧘", url: "https://stillness-zmf.pages.dev" },
];
